import { IsArray, IsDefined, IsInt, IsNumber, IsDate } from 'class-validator';
import { Type } from 'class-transformer';

export class GetStockVariancesDto {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  merchantId: number;

  @IsDefined()
  @IsArray()
  @IsNumber({}, { each: true })
  stockIdList: number[];

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  startDate: number;

  @IsDefined()
  @IsInt()
  @Type(() => Number)
  endDate: number;
}

export class GetStockVariancesDateDto {
  @IsDefined()
  @IsInt()
  @Type(() => Number)
  merchantId: number;

  @IsDefined()
  @IsArray()
  @IsNumber({}, { each: true })
  stockIdList: number[];

  @IsDefined()
  @IsDate()
  @Type(() => Date)
  countedDateTime: Date;
}